import React from 'react';
import {
  createRepresentativeEffect,
  updateRepresentativeEffect,
} from 'app/store/Profile/effects';
import { useAppDispatch } from 'app/store';
import { Representative } from 'types/profile';
import { RepresentativeDialogComponent } from './RepresentativeDialogComponent';
import { RepresentativeFormData } from '../../ProfileForm/types';

interface RepresentativeDialogProps {
  open: boolean;
  onClose: () => void;
  index?: number;
  represantative?: Representative | null;
}

export const RepresentativeDialog: React.FC<RepresentativeDialogProps> = ({
  open,
  onClose,
  index = -1,
  represantative,
}) => {
  const dispatch = useAppDispatch();
  const isEditing = !!represantative;

  const handleSubmit = async (formData: RepresentativeFormData) => {
    if (isEditing) {
      dispatch(updateRepresentativeEffect({ formData, index }));
    } else {
      dispatch(createRepresentativeEffect(formData));
    }
    onClose();
  };

  return (
    <RepresentativeDialogComponent
      open={open}
      onClose={onClose}
      onSubmit={handleSubmit}
      index={index}
      represantative={represantative}
      isEditing={isEditing}
    />
  );
};
